<template>
  <div class="p-0 flex flex-col items-center justify-start min-h-[75vh]">

    <!-- Modal -->
    <div
      id="large-modal"
      tabindex="-1"
      class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full"
    >
      <div class="relative w-full max-w-4xl max-h-full">
        <div class="relative bg-white rounded-lg shadow-sm">
          <!-- Modal header -->
          <div
            class="flex items-center justify-between p-4 md:p-5 border-b rounded-t border-gray-200"
          >
            <h3 class="text-xl font-medium text-gray-900">
              TIPOS DE MANUTENÇÃO
            </h3>
            <button
              type="button"
              class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
              data-modal-hide="large-modal"
            >
              <svg
                class="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span class="sr-only">Close modal</span>
            </button>
          </div>

          <!-- Modal body -->
          <div
            class="px-4 my-2 space-y-4 max-h-[53vh] overflow-auto text-start"
          >
            <div v-for="(item, index) in maintenanceInfo" :key="index">
              <h1 class="text-xl font-semibold uppercase tracking-wider">
                {{ item.title }}
              </h1>
              <p class="text-base leading-relaxed text-gray-500 ml-1">
                {{ item.info }}
              </p>
            </div>
          </div>

          <!-- Modal footer -->
          <div
            class="flex justify-center p-2 space-x-3 rtl:space-x-reverse border-t border-gray-200 rounded-b"
          >
            <button
              data-modal-hide="large-modal"
              type="button"
              class="py-2.5 px-5 ms-3 text-sm font-medium text-gray-700 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-gray-900 focus:z-10 focus:ring-4 focus:ring-gray-100"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="container max-w-screen-lg mx-auto">
      <div>
        <div class="bg-white rounded shadow-lg p-4 px-4 -mt-2">
          <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
            <div class="text-left block mb-4">
              <p class="mb-2 font-medium text-lg text-gray-900">
                {{ descriptionTitle }}
              </p>
              <p class="text-gray-500">
                Campos com <span class="text-red-500">*</span> são obrigatórios
              </p>

              <div class="flex justify-center">
                <img
                  v-if="selectedFileUrl || store?.maintenanceForm?.values?.imagesName"
                  :src="selectedFileUrl ?? fileUrl + store?.maintenanceForm?.values?.imagesName"
                  alt="Foto do setor"
                  class="mt-10 mb-auto rounded-md w-60 max-h-60 hidden md:block"
                />
              </div>
            </div>

            <div id="form-fields" class="lg:col-span-2">
              <div
                class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
              >
                <!-- tipo -->
                <div class="md:col-span-2">
                  <div class="md:col-span-2">
                    <label
                      class="text-left flex pl-1 text-xs text-[#2b3038]"
                      for="maintenanceForm.type"
                    >
                      Manutenção do tipo <a class="text-red-600 ml-1">*</a>

                      <!-- info -->
                      <button
                        data-modal-target="large-modal"
                        data-modal-toggle="large-modal"
                        type="button"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="h-5 w-5 text-green-600 ml-1 -mt-1"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
                          />
                        </svg>
                      </button>
                    </label>

                    <div class="h-10 flex rounded items-center">
                      <SimpleSelect
                        class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                        :data="maintenanceTypes"
                        :initialValue="store.maintenanceForm.type"
                        @selected-data="
                          (val) => (store.maintenanceForm.type = val.name)
                        "
                      />
                    </div>
                  </div>

                  <span
                    name="maintenanceForm.type"
                    class="text-red-600 text-sm"
                  />
                </div>

                <!-- motivo -->
                <div class="md:col-span-3 -mt-1">
                  <BaseInput
                    type="text"
                    name="maintenanceForm.values.motivo"
                    v-model="store.maintenanceForm.values.motivo"
                    :info="'Motivo'"
                    label="Motivo"
                    :required-field="true"
                    :activeDefault="false"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store.maintenanceForm.values.motivo = undefined"
                      />
                    </template>
                  </BaseInput>
                </div>

                <!-- checklist -->
                <div class="md:col-span-5 my-1 mb-0">
                  <h4 class="text-lg w-full text-start font-normal flex -ml-1 uppercase">
                    <component
                      class="h-6 w-6 mt-auto mb-auto mx-1 text-green-700"
                      :is="PhListChecks"
                    />
                    Checklist do item
                  </h4>
                  <Transition mode="out-in">
                    <div
                      :key="selectedComponent"
                      class="lg:col-span-2 border p-3 rounded-md my-2"
                      v-if="selectedComponent"
                    >
                      <component
                        :is="checklistComponent"
                        :key="selectedComponent"
                        :checklist="selectedComponent"
                      />
                    </div>
                  </Transition>
                </div>

                <!-- descrição -->
                <div class="md:col-span-5">
                  <BaseInput
                    type="text"
                    name="itensForm.description"
                    v-model="store.maintenanceForm.values.description"
                    :info="'Observações / Decrição'"
                    label="Observações / Decrição"
                    :required-field="false"
                    :activeDefault="false"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store.maintenanceForm.values.description = undefined"
                      />
                    </template>
                  </BaseInput>
                </div>

                <!-- fluxo da imagem -->
                <div class="flex justify-center">
                  <img
                    v-if="selectedFileUrl || store?.maintenanceForm?.values?.imagesName"
                    :src="
                      selectedFileUrl ?? fileUrl + store?.maintenanceForm?.values?.imagesName
                    "
                    alt="Foto do setor"
                    class="mt-2 rounded-md w-60 max-h-60 block md:hidden"
                  />
                </div>

                <div class="md:col-span-5 mt-2 flex h-10">
                  <label
                    class="cursor-pointer bg-gray-100 hover:bg-gray-300 transition-all min-w-[8rem] h-10 rounded-l-md rounded-r-none"
                  >
                    <!-- <i class="fa-solid fa-helmet-safety"></i> -->

                    <div class="flex mt-auto mb-auto h-full">
                      <div class="w-full mt-auto mb-auto flex justify-center">
                        <component
                          :is="selectedFileName ? PhImage : PhFileImage"
                          class="w-5 h-5 mr-1"
                          :class="[
                            selectedFileName
                              ? 'text-green-500'
                              : 'text-gray-500',
                          ]"
                        />

                        Foto
                      </div>
                    </div>
                    <input
                      type="file"
                      class="hidden"
                      @change="handleFileChange"
                    />
                  </label>
                  <input
                    type="text"
                    style="padding-left: 10px !important"
                    class="border rounded w-full h-10 rounded-r-md rounded-l-none"
                    :value="selectedFileName"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="flex justify-center mt-8">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CleanInputButton from '../../utils/CleanInputButton.vue'
import SimpleSelect from '@/components/Select/SimpleSelect.vue'

import Checklist from './checklists/checklist.vue'
import ExtinguisherForm from './checklists/extinguisher.vue'
import LightingForm from './checklists/lighting.vue'
import HydrantForm from './checklists/hydrant.vue'
import SirenForm from './checklists/siren.vue'

import BaseInput from '@/components/Inputs/BaseInput.vue'
import { showToast as toast } from '@/helpers/UseToasts'
import { maintenanceTypes } from '../../lookups/form'
import { dataExtinguisher } from '../../store'
import { initFlowbite } from 'flowbite'
import { markRaw } from 'vue'
import {
  hidranteChecklist,
  iluminacaoChecklist,
  acionador_sireneChecklist,
  extintorChecklist,
  maintenanceInfo
} from './../../lookups/checklist'

import {
  PhFileImage,
  PhImage,
  PhInfo,
  PhListChecks
} from '@phosphor-icons/vue'

export default {
  components: {
    SimpleSelect,
    CleanInputButton,
    BaseInput,
    ExtinguisherForm,
    HydrantForm,
    LightingForm,
    SirenForm
  },
  props: {
    descriptionTitle: String
  },
  data () {
    const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
    const checklistComponent = markRaw(Checklist)

    return {
      selectedFileName: undefined,
      selectedFileUrl: undefined,
      store: dataExtinguisher.state,
      dataExtinguisher,
      maintenanceTypes,
      fileUrl,
      toast,

      // icons
      PhFileImage,
      PhImage,
      PhListChecks,
      PhInfo,

      // checklist component
      checklistComponent,

      // checklist options
      checklistActive: null,
      hidranteChecklist,
      iluminacaoChecklist,
      acionador_sireneChecklist,
      extintorChecklist,
      maintenanceInfo
    }
  },
  computed: {
    selectedComponent () {
      const type = this.store.itensForm?.type?.value

      if (type == 'extintor' || this.store.itensForm?.type == 'EXTINTOR') {
        this.checklistActive = this.extintorChecklist
        return this.checklistActive
      }

      if (type == 'hidrante' || this.store.itensForm?.type == 'HIDRANTE') {
        this.checklistActive = this.hidranteChecklist
        return this.checklistActive
      }

      if (type == 'iluminacao' || this.store.itensForm?.type == 'ILUMINAÇÃO') {
        this.checklistActive = this.iluminacaoChecklist
        return this.checklistActive
      }

      if (type == 'acionador_sirene' || this.store.itensForm?.type == 'ACIONADORES E SIRENES') {
        this.checklistActive = this.acionador_sireneChecklist
        return this.checklistActive
      }

      if (type == 'acionador_sirene' || this.store.itensForm?.type == 'SISTEMA DE RESGATE') {
        this.checklistActive = this.acionador_sireneChecklist
        return this.checklistActive
      }

      this.checklistActive = null
      return this.checklistActive
    }
  },
  methods: {
    handleFileChange (event) {
      const file = event.target.files[0]
      if (file) {
        const allowedExtensions = ['webp', 'png', 'gif', 'jpeg', 'jpg']
        const fileExtension = file.name.split('.').pop().toLowerCase()
        if (allowedExtensions.includes(fileExtension)) {
          this.selectedFileName = file.name
          this.selectedFileUrl = URL.createObjectURL(file)

          this.store.maintenanceForm.values.imagesName = this.selectedFileName
          this.store.maintenanceForm.values.images = file
        } else {
          return this.toast(
            'Aviso',
            'Apenas imagens do tipo: webp, png, gif, jpeg e jpg são aceitas',
            'info'
          )
        }
      }
    }
  },
  mounted () {
    initFlowbite()
  }
}
</script>

<style lang="scss" scoped>
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
